import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { NgxMediaThumbnailComponent } from './media-thumbnail.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		MatTooltipModule
	],
	declarations: [
		NgxMediaThumbnailComponent
	],
	exports: [
		NgxMediaThumbnailComponent
	]
})
export class NgxMediaThumbnailModule {}
